import US from 'iview/dist/locale/en-US'
import enE from 'element-ui/lib/locale/lang/en'

const enUS = Object.assign({
  menu: {
    home: 'Home',
    system: 'System setting',
    system_management: {
      Role: 'Role',
      Department: 'Department',
      Account: 'Account',
      WorkTime: 'Shift',
      WorkType: 'Worker type',
      RoleEdit: 'Role edit',
      DepartmentEdit: 'Department Edit',
      AccountEdit: 'Account Edit',
      WorkTimeEdit: 'Shift Edit',
      WorkTypeEdit: 'Worker type Edit',
      systeminfo: 'Information',
      SystemAuth: 'Authorization'
    },
    Device: 'Devices setting',
    Device_management: {
      RouterList: 'Router',
      RouterEdit: 'Router Edit',
      Collector: 'Machine',
      CollectorEdit: 'Machine Edit',
      CollectorGroup: 'Machine Group',
      CollectorGroupEdit: 'Machine group Edit'
    },
    Card: 'Card setting',
    CardEdit: 'Card Edit',
    People: 'Person setting',
    PeopleEdit: 'Person Edit',
    Product: 'Production setting',
    ProductEdit: 'Production Edit',
    Order: 'Order setting',
    OrderEdit: 'Order Edit',
    Plan: 'Production Planning',
    Plan_Management: {
      Production_plan: 'Order planning',
      Production_management: 'Order arrangement',
      Production_order: 'Order schedule'
    },
    Monitor: 'Monitoring',
    Monitor_Monitoring: {
      Collector: 'Machine state',
      Order: 'Order state'
    },
    Data: 'Report',
    Data_output: {
      Order: 'Order history',
      device: 'Machine history',
      Worker: 'Worker history',
      MaintainList: 'Maintain history',
      MaintainEdit: 'Maintain Edit'
    },
    Setting: 'User Setting'
  },
  system: {
    Account: {
      New_account: 'New account',
      edit_account: 'Account edit',
      please_enter: 'Please enter something',
      please_choose: 'Please choose something',
      Return_to_account_list: 'Retern to account list',
      User_name: 'User name',
      User_name_message: 'Please enter user name',
      Name: 'Name',
      Name_message: 'Please enter name',
      Role: 'Role',
      Role_message: 'Please choose role',
      Worker_number: 'Worker number',
      Department: 'Department',
      Department_message: 'Please choose department',
      Telephone: 'Telephone',
      Email: 'E-mail',
      QQ: 'QQ',
      Wechat: 'Wechat',
      telephone: 'Telephone:',
      email: 'E-mail:',
      qq: 'QQ:',
      wechat: 'Wechat:',
      save: 'Save',
      index: 'No.',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      reseat: 'Reset',
      error: 'Error',
      error_message1: '<p>Repeated account</p>',
      error_message2: '<p>Repeated account</p>',
      delete_message: 'Do you want to delete it?'
    },
    Department: {
      New_Department: 'New Department',
      edit_Department: 'Department edit',
      index: 'No.',
      Department: 'Department',
      Authorization: 'Authorization',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      Return_to_depatement_list: 'Retern to department list',
      name: 'Name',
      Move_left: 'Move to the left',
      Move_right: 'Move to the right',
      save: 'save',
      All_authorization: 'All authorization',
      Department_authorization: 'Department authorization'
    },
    Role: {
      New_Role: 'New role',
      edit_Role: 'Role edit',
      index: 'No.',
      Role: 'Role',
      Authorization: 'Authorization',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      Return_to_role_list: 'Return to role list',
      name: 'Name',
      Move_left: 'Move to the left',
      Move_right: 'Move to the right',
      save: 'Save',
      All_authorization: 'All authorization',
      Role_authorization: 'Role authorization'
    },
    workTime: {
      New_workTime: 'New shift',
      edit_workTime: 'Shift edit',
      index: 'No.',
      name: 'Name',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      please_choose: 'Please choose something',
      startTime: 'Start time',
      endTime: 'End time',
      Return_to_workTime_list: 'Retern to shift list',
      save: 'Save'
    },
    workType: {
      New_workType: 'New Worker type',
      edit_workType: 'Worker type edit',
      index: 'No.',
      name: 'Name',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      Return_to_workType_list: 'Return to worker type list',
      save: 'Save',
      yes: 'Yes',
      no: 'No',
      outputValid: 'Effective production',
      monopoly: 'Occupy machine',
      maintain: 'Maintain mode',
      warn: 'Shutdown alarm',
      Sorting: 'Sorting',
      display: 'Dashboard',
      malfunction: 'Fault calculation',
      remark: 'Remark'
    },
    SystemAuth: {
      Information: 'Information',
      systemVersion: 'System version:',
      systemDealTime: 'Expiration date:',
      please_enter: 'Please enter something',
      save: 'Save',
      save_success: 'Save success',
      systemAuthCode: 'Authorization code'
    },
    SystemInfo: {
      Information: 'Information',
      Contect: 'Contect',
      systemName: 'System name:',
      please_enter: 'Please enter something',
      name: 'Company name:',
      contact: 'Contect name:',
      address: 'Company Address:',
      phone: 'Telephone:',
      fax: 'Fax:',
      eMail: 'E-mail:',
      save: 'Save',
      save_success: 'Save success',
      warnLimitTime: 'Shutdown alarm interval:'
    }
  },
  device: {
    collector: {
      New_collector: 'New machine',
      edit_collector: 'Machine edit',
      Return_to_collector_list: 'Return to machine list',
      name: 'Name',
      deviceNo: 'No.',
      routerID: 'Router',
      type: 'Machine type',
      computeType: 'Capacity method',
      roller: 'Roller',
      weft_density: 'Weft density',
      length: 'Roller circumference',
      count: 'Tapes number',
      width: 'Tape width',
      deviceCompany: 'Manufacturer',
      deviceModel: 'Machine model',
      buyTime: 'Purchase time',
      deviceLifeTime: 'Service life（year）',
      please_enter: 'Please enter something',
      please_enter_mm: 'Please enter something(Unit:mm)',
      save: 'Save',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      error: 'Error',
      error_message1: '<p>The information is not completed </p>',
      error_message2: 'must be Integer',
      remark: 'Remark',
      Message: {
        name: 'Please enter name',
        deviceNo: 'Please enter number',
        computeType: 'Please enter calculation method',
        routerID: 'Please enter router',
        length: 'Please enter Roller circumference',
        count: 'Please enter tapes',
        width: 'Please enter width'
      }
    },
    group: {
      New_group: 'New Machine group',
      edit_group: 'Machine group edit',
      Return_to_group_list: 'Return to machine group list',
      please_enter: 'Please enter something',
      save: 'Save',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      index: 'No.',
      name: 'Name',
      chosen: 'Have chosen',
      devices: 'Machine',
      remark: 'Remark',
      width: 'Width',
      router: 'Router'
    },
    router: {
      New_router: 'New Router',
      edit_router: 'Router edit',
      Return_to_router_list: 'Retern to router list',
      please_enter: 'Please enter something',
      index: 'No.',
      name: 'Router code',
      AnotherName: 'Router Name',
      linkType: 'Network type',
      channel: 'Signal channel',
      remark: 'Remark',
      save: 'Save',
      action: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      mod: 'Network Type',
      Lan: 'Local LAN',
      Internet: 'Internet',
      time: 'Rearrange',
      save_success: 'The system and collector already rearrange'
    }
  },
  Card: {
    New_Card: 'New card',
    edit_Card: 'Card edit',
    Return_to_Card_list: 'Return to card list',
    please_enter: 'Please enter something',
    index: 'No.',
    userName: 'Holder',
    cardNo: 'Card number',
    workTypeName: 'Work type',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    delete_message: 'Do you want to delete it?',
    save: 'Save',
    error: 'Error',
    error_message1: '<p>Repeated card</p>',
    error_message2: '<p>The information is not completed</p>'
  },
  Product: {
    New_Product: 'New production',
    edit_Product: 'Production edit',
    Return_to_Product_list: 'Return to production list',
    please_enter: 'Please enter something',
    index: 'No.',
    productNo: 'Production No.',
    name: 'Name',
    latDensity: 'Weft density',
    kaidu: 'Tension',
    width: 'Width',
    specifications: 'Specification',
    valid: 'Effectivity',
    yes: 'Yes',
    no: 'No',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    delete_message: 'Do you want to delete it?',
    save: 'Save',
    error: 'Error',
    error_message: '<p>The information is not completed</p>',
    please_enter_mm: 'Please enter something(Unit:mm)',
    please_enter_latDensity: 'Please enter something(Unit:weft/cm)',
    please_enter_kaidu: 'Please enter something(≧1)',
    Message: {
      productNo: 'Please enter production No.',
      name: 'Please enter name',
      latDensity: 'Please enter weft density',
      kaidu: 'Please enter tension',
      width: 'Please enter width'
    }
  },
  Order: {
    New_Order: 'New order',
    edit_Order: 'Order edit',
    Return_to_Order_list: 'Return to order list',
    please_enter: 'Please enter something',
    please_enter_date: 'Please enter date',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    error: 'Error',
    error_message1: '<p>No production is added to the order</p>',
    error_message2: '<p>The order information is not filled in </p>',
    error_message3: '<p>Quantity not completed</p>',
    error_message4: '<p>Unit not completed</p>',
    error_message5: '<p>Delivery date not completed</p>',
    error_message6: '<p>請先選擇左側產品</p>',
    delete_message: 'Do you want to delete it? ',
    change_message: 'Do you want to open case?',
    orderNo: 'Order number',
    customer: 'Customer',
    ordersTime: 'Order date',
    salesman: 'Sales',
    index: 'No.',
    productNo: 'Production No.',
    num: 'Quantity',
    unit: 'Unit',
    attritionRate: 'Loss rate(%)',
    deliveryTime: 'Delivery date',
    remark: 'Remark',
    add: 'Add to order',
    Product_list: 'Production list',
    search: 'Item/Name',
    No_scheduling: 'No scheduling',
    Not_production: 'Nonproduction',
    Producting: 'Production',
    Case_closed: 'Finish',
    name: 'Name',
    Meter: 'Meter',
    Yard: 'Yard',
    Gross: 'Gross',
    Status: 'Status',
    Message: {
      orderNo: 'Please enter production No.',
      ordersTime: 'Please enter order date',
      customer: 'Please enter Customer',
      salesman: 'Please enter Sales'
    }
  },
  Login: {
    username: 'Please enter user name',
    password: 'Please enter password',
    systemCode: 'Please enter system code',
    language: 'Please choose language',
    login: 'Login',
    system: 'System login',
    changePw: 'change password',
    logout: 'log out',
    Information: 'personal setting'
  },
  ChangePw: {
    oldPassword: 'Enter old password:',
    newPassword: 'Enter new password',
    comfirmPassword: 'Comfirm new password',
    save: 'Save',
    error: 'The two passwords are inconsistent',
    success: 'Modify successfully',
    ChangePw: 'Change the password'
  },
  monitor: {
    Collector: {
      index: 'No.',
      name: 'Name',
      group: 'Group',
      deviceNo: 'Item',
      rpm: 'Machine RPM',
      status: 'Machine status',
      status1: 'Devices status',
      error: 'Fault information',
      worker: 'Workers',
      workType: 'Card status',
      lastTime: 'Time',
      timeout: 'Offline',
      trial: 'Trial',
      standby: 'Standby',
      run: 'Running',
      orderNo: 'Order No.',
      producNo: 'Production No.',
      stop: 'Standby',
      warp: ' Warp ',
      weft: ' Weft ',
      thread: ' Thread ',
      roll: ' Roller '
    },
    Order: {
      index: 'No.',
      orderNo: 'Order No.',
      producNo: 'Production No.',
      salesman: 'Sales',
      ordersTime: 'Order date',
      output: 'Production',
      num: 'Order quantity',
      unit: 'Unit',
      countdata: 'Machine',
      name: 'Name',
      rpm: 'Machine RPM',
      worker: 'Worker',
      workType: 'Card Status',
      DailyOutput: 'Daily production',
      deliveryTime: 'Order Delivery date',
      today: 'Today production',
      completed: 'Completed production',
      fastestdelivery: 'Estimated delivery',
      please_enter_date1: 'Start date of order delivery',
      please_enter_date2: 'End date of order delivery',
      Meter: 'Meter',
      Yard: 'Yard',
      Gross: 'Gross'
    }
  },
  data: {
    Device: {
      name: 'Machine',
      date: 'Date',
      group: 'Group',
      output: 'Production',
      unit: 'Unit',
      runTotalTime: 'Run total time',
      stopTime: 'Stop times',
      stopTotalTime: 'Stop total time',
      error1Time: 'Warp fault times',
      error1TotalTime: 'Warp fault time',
      error2Time: 'Weft fault times',
      error2TotalTime: 'Weft fault time',
      error3Time: 'Catch thread fault times',
      error3TotalTime: 'Catch thread fault time',
      error4Time: 'Take up fault times',
      error4TotalTime: 'Take up fault time',
      S: 'Sec',
      M: 'Min',
      H: 'Hour',
      D: 'Day',
      Meter: 'Meter',
      output_report: 'Capacity report',
      run_report: 'Running status report',
      please_enter: 'Please choose',
      please_enter_date: 'Please choose date',
      start_date: 'Start time',
      end_date: 'End time',
      ok: 'OK',
      out: 'Output',
      status: 'Running status'
    },
    Order: {
      orderNo: 'Order No.',
      productNo: 'Production No.',
      collectorName: 'Machine',
      salesman: 'Sales',
      customer: 'Customer',
      ordersTime: 'Order date',
      productTime: 'Production time',
      output: 'Actual output',
      target: 'Target output',
      num: 'Order quantity',
      unit: 'Unit',
      deliveryTime: 'Delivery date',
      Meter: 'Meter',
      Yard: 'Yard',
      Gross: 'Gross',
      Order_report: 'Order report',
      ok: 'OK',
      out: 'Output',
      please_enter: 'Please choose something',
      please_enter_date: 'Please choose the date',
      start_date: 'Start date',
      end_date: 'End date',
      time_range: 'Time range',
      No_scheduling: 'No scheduling',
      Not_production: 'Nonproduction',
      Producting: 'Production',
      Case_closed: 'Finish',
      status: 'Status',
      history: 'Order history'
    }
  },
  setting: {
    Basic_Information: 'Basic information',
    company_information: 'Company information',
    Contact_information: 'Contact',
    save: 'Save',
    please_enter: 'Please enter something',
    username: 'User name:',
    name: 'Name:',
    company: 'Company:',
    workNo: 'Work No.',
    department: 'Department:',
    workPosition: 'Position:',
    role: 'Role:',
    phone: 'Telephone:',
    eMail: 'E-mail:',
    qq: 'QQ:',
    wechat: 'Wechat:',
    System_setting: 'System setting',
    language: 'language:',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: 'Machine name',
      name: 'Machine',
      one: 'Batch 1',
      two: 'Batch 2',
      three: 'Batch 3',
      four: 'Batch 4',
      fiv: 'Batch 5',
      six: 'Batch 6',
      orderNo: 'Order No.',
      productNo: 'Production No.',
      row: 'Tapes number',
      delete_message: 'Are you sure stop production?',
      yes: 'Start',
      no: 'Stop'
    },
    Order: {
      orderNo: 'Order No.',
      customer: 'Customer',
      ordersTime: 'Order date',
      salesman: 'Sales',
      index: 'No.',
      productNo: 'Production No.',
      num: 'Quantity',
      unit: 'Unit',
      attritionRate: 'Loss rate(%)',
      output: 'Quantity completion',
      deliveryTime: 'Delivery date',
      action: 'Operation',
      Meter: 'Meter',
      Yard: 'Yard',
      Gross: 'Gross',
      delete_message: 'Are you sure close the order?',
      case1: 'Close PO',
      case2: 'PO closed'
    },
    Production: {
      productNo: 'Production No.',
      productName: 'Production Name',
      deliveryTime: 'Delivery date',
      num: 'Quantity',
      name: 'Machine name',
      count: 'Type',
      width: 'Width',
      collectorName: 'Machine name',
      orderNo: 'Order No.',
      planIndex: 'Batch',
      row: 'Tapes',
      action: 'Operation',
      delete: 'Delete',
      error: 'Error',
      error_message: '<p>Unselected type</p>',
      planClick: 'List of planned production',
      please_enter: 'Please enter something',
      deviceNo: 'Item',
      save: 'Save',
      save1: 'Send order',
      save2: 'Insert order',
      save3: 'Parallel order',
      No_scheduling: 'No scheduling',
      Not_production: 'Nonproduction',
      Producting: 'Production',
      Case_closed: 'Finish',
      Status: 'Status',
      no: 'Stop',
      delete_message: 'Do you want to delete it?',
      searchCollector: 'Machine name',
      chooose_order: '1.Choose Order',
      choose_device: '2.Choose Machine',
      choose_plan: '3.Planned Production',
      list: 'List of planned production',
      message: 'This production has been closed'
    }
  },
  People: {
    index: 'No.',
    name: 'Name',
    workNo: 'Worker No.',
    sex: 'Sex',
    boy: 'Man',
    girl: 'Woman',
    phone: 'Telephone',
    entryTime: 'Entry time',
    wechat: 'Wechat',
    qq: 'QQ',
    working: 'On Job',
    working1: 'On Job',
    working2: 'Departure',
    yes: 'Yes',
    no: 'No',
    action: 'Operation',
    edit: 'Edit',
    edit_People: 'Edit staff',
    Return_to_People_list: 'Return to staff list',
    please_enter: 'Please enter',
    please_enter_date: 'Please selete the date',
    save: 'Save'
  },
  Maintain: {
    index: 'No.',
    DeviceName: 'Machine Name',
    username: 'Operator',
    startTime: 'Start Time',
    endTime: 'End Time',
    remark: 'Remark',
    action: 'Operation',
    edit: 'Edit',
    edit_Maintain: 'Edit Maintain Record',
    Return_to_Maintain_list: 'Return to Maintain List',
    save: 'Save',
    please_enter: 'Please enter',
    please_enter_date1: 'Start date of Start Time',
    please_enter_date2: 'End date of Start Time'
  },
  Permission: {
    super_admin: 'Super System setting',
    system: 'System setting',
    device: 'Devices setting',
    card: 'Card setting',
    people: 'Person setting',
    product: 'Production setting',
    order: 'Order setting',
    production_plan: 'Production Planning',
    monitor: 'Monitoring',
    report_export: 'Report',
    R: 'R',
    W: 'W',
    RW: 'RW'
  }
}, US, enE)

export default enUS



// WEBPACK FOOTER //
// ./src/lang/en-US.js